/**
 * Color maps for enum/tri-state field values.
 *
 * Normal:   low → red,   med → orange, high → green
 * Inverted: low → green, med → orange, high → red
 *   Use inverted for fields where high is semantically bad (e.g. severity, risk).
 */
export const ENUM_COLORS: Record<string, string> = {
  low: 'red',
  med: 'orange',
  high: 'green',
  true: 'green',
  false: 'red',
  unknown: 'orange',
}

export const ENUM_COLORS_INVERTED: Record<string, string> = {
  low: 'green',
  med: 'orange',
  high: 'red',
  true: 'green',
  false: 'red',
  unknown: 'orange',
}

export function getEnumColorMap(inverted?: boolean): Record<string, string> {
  return inverted ? ENUM_COLORS_INVERTED : ENUM_COLORS
}
